import script from "./FreeBet.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeBet.vue?vue&type=script&setup=true&lang=js"

import "./FreeBet.vue?vue&type=style&index=0&id=a6530462&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6530462"]])

export default __exports__